import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {AppBar, Box, Container, Grid, Typography} from '@material-ui/core';
import { useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    container: {
        // border: '1px solid orange',
        height: 250,
        width: '1280px',
    },
    textColor : {
        color: theme.palette.primary.main
    }
}))

const Header = () => {
    
    const classes = useStyles();
    const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));

    return (
            <Container maxWidth={isMobile ? 'sm' : 'lg'}>
                <Grid container direction="row" alignContent="center" className={classes.container}>
                    <Grid item xs={12} md={6}>
                        <Typography color="textPrimary" variant="subtitle1" gutterBottom>
                            <b>hi 👋 my name is</b>
                        </Typography>
                        <Typography color="textPrimary" variant="h3" gutterBottom>
                            <b>Ryan Tavcar</b>
                        </Typography>
                        <Typography color="textPrimary" variant="subtitle2" gutterBottom>
                            lets get in touch 👉 <b className={classes.textColor}>Ryan.Tavcar@gmail.com</b>
                        </Typography>
                    </Grid> 
                </Grid>
            </Container>
    )
}

export default Header
